import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Partner Dashboard - Login
      "partner.login.title": "Partner Dashboard",
      "partner.login.subtitle": "Login to manage your orders",
      "partner.login.password": "Password",
      "partner.login.passwordPlaceholder": "Enter your password",
      "partner.login.loginButton": "Sign in",
      "partner.login.loggingIn": "Signing in...",
      // Partner Dashboard - Header
      "partner.header.title": "Partner Dashboard",
      "partner.header.pendingOrders": "pending",
      // Partner Dashboard - Status
      "partner.status.online": "Online",
      "partner.status.offline": "Offline",
      "partner.status.goOnline": "Go Online",
      "partner.status.goOffline": "Go Offline",
      // Partner Dashboard - Tabs
      "partner.tabs.pending": "Pending",
      "partner.tabs.accepted": "Accepted",
      "partner.tabs.all": "All",
      // Partner Dashboard - Orders
      "partner.orders.noOrders": "No orders at the moment",
      "partner.orders.items": "Items",
      "partner.orders.customer": "Customer",
      "partner.orders.delivery": "Delivery",
      "partner.orders.subtotal": "Your earnings 💰",
      "partner.orders.deliveryFee": "Delivery fee",
      "partner.orders.total": "Total",
      "partner.orders.note": "Note",
      "partner.orders.prepTime": "Preparation time",
      "partner.orders.selectPrepTime": "Select...",
      "partner.orders.minutes": "minutes",
      "partner.orders.accept": "Accept",
      "partner.orders.reject": "Reject",
      "partner.orders.startPreparation": "Start preparation",
      "partner.orders.readyForDelivery": "Ready for delivery",
      "partner.orders.markDelivered": "Mark as delivered",
      // Partner Dashboard - Status Badges
      "partner.statusBadges.pending": "Pending",
      "partner.statusBadges.confirmed": "Confirmed",
      "partner.statusBadges.preparing": "Preparing",
      "partner.statusBadges.outForDelivery": "Out for delivery",
      "partner.statusBadges.delivered": "Delivered",
      "partner.statusBadges.rejected": "Rejected",
      // Partner Dashboard - Notifications
      "partner.notifications.newOrder": "New order(s)!",
      "partner.notifications.orderAccepted": "Order accepted",
      "partner.notifications.orderRejected": "Order rejected",
      "partner.notifications.statusUpdated": "Status updated",
      "partner.notifications.welcome": "Welcome",
      "partner.notifications.disconnected": "Disconnected",
      "partner.notifications.selectPrepTime": "Please select a preparation time",
      // Partner Dashboard - Reject
      "partner.reject.title": "Reject Order",
      "partner.reject.reason": "Reason for rejection",
      "partner.reject.reasons.closed": "Restaurant is closed",
      "partner.reject.reasons.busy": "Too busy right now",
      "partner.reject.reasons.itemUnavailable": "Item(s) unavailable",
      "partner.reject.reasons.deliveryTooFar": "Delivery address too far",
      "partner.reject.reasons.other": "Other reason",
      "partner.reject.confirm": "Confirm rejection",
      "partner.reject.cancel": "Cancel",
      "partner.reject.warning": "The customer will be automatically refunded.",
      "partner.language": "Language",
      // Site translations
      "nav.home": "Home",
      "nav.services": "Services",
      "nav.restaurants": "Restaurants",
      "nav.about": "About Us",
      "nav.contact": "Contact",
      "hero.tagline": "Precision. Performance. Trust.",
      "hero.title": "Intelligent Delivery Infrastructure",
      "hero.subtitle": "Professional delivery solutions for businesses and individuals in Finland",
      "hero.cta": "Get Started",
      "services.title": "Our Services",
      "services.pickup.title": "Pickup Delivery",
      "services.pickup.description": "Pick up items from stores, restaurants, or parcel points",
      "services.pickup.cta": "Order Now",
      "services.package.title": "Send a Package",
      "services.package.description": "Person-to-person delivery within 40km radius",
      "services.package.cta": "Send Package",
      "services.restaurants.title": "Restaurants & Shops",
      "services.restaurants.description": "Order from local restaurants and shops",
      "services.restaurants.cta": "Browse",
      "services.van.title": "Van / Moving",
      "services.van.description": "Dedicated van for furniture and large items",
      "services.van.cta": "Book Van",
      "stats.deliveries": "Deliveries",
      "stats.partners": "Partners",
      "stats.cities": "Cities",
      "stats.rating": "Rating",
      "features.title": "Why Choose Us",
      "features.fast.title": "Fast Delivery",
      "features.fast.description": "Same-day delivery across Finland",
      "features.tracking.title": "Real-time Tracking",
      "features.tracking.description": "Track your delivery in real-time",
      "features.secure.title": "Secure Payments",
      "features.secure.description": "Safe and secure payment options",
      "features.support.title": "24/7 Support",
      "features.support.description": "Always here to help",
      "partner.title": "Become a Partner",
      "partner.description": "Join our network of restaurants and shops",
      "partner.cta": "Partner with Us",
      "courier.title": "Become a Courier",
      "courier.description": "Earn money delivering with IBIIP",
      "courier.cta": "Apply Now",
      "footer.company": "IBIIP OY",
      "footer.address": "Karviaistie 12, 00700 Helsinki",
      "footer.businessId": "Business ID",
      "footer.rights": "All rights reserved"
    }
  },
  fi: {
    translation: {
      // Partner Dashboard - Login
      "partner.login.title": "Kumppanin hallintapaneeli",
      "partner.login.subtitle": "Kirjaudu sisään hallitaksesi tilauksiasi",
      "partner.login.password": "Salasana",
      "partner.login.passwordPlaceholder": "Syötä salasanasi",
      "partner.login.loginButton": "Kirjaudu sisään",
      "partner.login.loggingIn": "Kirjaudutaan...",
      // Partner Dashboard - Header
      "partner.header.title": "Kumppanin hallintapaneeli",
      "partner.header.pendingOrders": "odottavat",
      // Partner Dashboard - Status
      "partner.status.online": "Online",
      "partner.status.offline": "Offline",
      "partner.status.goOnline": "Mene online-tilaan",
      "partner.status.goOffline": "Mene offline-tilaan",
      // Partner Dashboard - Tabs
      "partner.tabs.pending": "Odottavat",
      "partner.tabs.accepted": "Hyväksytyt",
      "partner.tabs.all": "Kaikki",
      // Partner Dashboard - Orders
      "partner.orders.noOrders": "Ei tilauksia tällä hetkellä",
      "partner.orders.items": "Tuotteet",
      "partner.orders.customer": "Asiakas",
      "partner.orders.delivery": "Toimitus",
      "partner.orders.subtotal": "Ansaitsit 💰",
      "partner.orders.deliveryFee": "Toimitusmaksu",
      "partner.orders.total": "Yhteensä",
      "partner.orders.note": "Huomautus",
      "partner.orders.prepTime": "Valmistusaika",
      "partner.orders.selectPrepTime": "Valitse...",
      "partner.orders.minutes": "minuuttia",
      "partner.orders.accept": "Hyväksy",
      "partner.orders.reject": "Hylkää",
      "partner.orders.startPreparation": "Aloita valmistus",
      "partner.orders.readyForDelivery": "Valmis toimitettavaksi",
      "partner.orders.markDelivered": "Merkitse toimitetuksi",
      // Partner Dashboard - Status Badges
      "partner.statusBadges.pending": "Odottaa",
      "partner.statusBadges.confirmed": "Vahvistettu",
      "partner.statusBadges.preparing": "Valmistetaan",
      "partner.statusBadges.outForDelivery": "Toimituksessa",
      "partner.statusBadges.delivered": "Toimitettu",
      "partner.statusBadges.rejected": "Hylätty",
      // Partner Dashboard - Notifications
      "partner.notifications.newOrder": "Uusia tilauksia!",
      "partner.notifications.orderAccepted": "Tilaus hyväksytty",
      "partner.notifications.orderRejected": "Tilaus hylätty",
      "partner.notifications.statusUpdated": "Tila päivitetty",
      "partner.notifications.welcome": "Tervetuloa",
      "partner.notifications.disconnected": "Yhteys katkaistu",
      "partner.notifications.selectPrepTime": "Valitse valmistusaika",
      // Partner Dashboard - Reject
      "partner.reject.title": "Hylkää tilaus",
      "partner.reject.reason": "Hylkäyksen syy",
      "partner.reject.reasons.closed": "Ravintola on suljettu",
      "partner.reject.reasons.busy": "Liian kiireistä juuri nyt",
      "partner.reject.reasons.itemUnavailable": "Tuote(t) loppu",
      "partner.reject.reasons.deliveryTooFar": "Toimitusosoite liian kaukana",
      "partner.reject.reasons.other": "Muu syy",
      "partner.reject.confirm": "Vahvista hylkäys",
      "partner.reject.cancel": "Peruuta",
      "partner.reject.warning": "Asiakas saa automaattisesti hyvityksen.",
      "partner.language": "Kieli",
      // Site translations
      "nav.home": "Etusivu",
      "nav.services": "Palvelut",
      "nav.restaurants": "Ravintolat",
      "nav.about": "Tietoa meistä",
      "nav.contact": "Yhteystiedot",
      "hero.tagline": "Tarkkuus. Suorituskyky. Luottamus.",
      "hero.title": "Älykäs toimitusinfrastruktuuri",
      "hero.subtitle": "Ammattimaiset toimitusratkaisut yrityksille ja yksityishenkilöille Suomessa",
      "hero.cta": "Aloita",
      "services.title": "Palvelumme",
      "services.pickup.title": "Noutokuljetukset",
      "services.pickup.description": "Nouda tuotteet kaupoista, ravintoloista tai pakettiautomaateista",
      "services.pickup.cta": "Tilaa nyt",
      "services.package.title": "Lähetä paketti",
      "services.package.description": "Henkilöstä henkilölle toimitus 40 km säteellä",
      "services.package.cta": "Lähetä paketti",
      "services.restaurants.title": "Ravintolat ja kaupat",
      "services.restaurants.description": "Tilaa paikallisilta ravintoloilta ja kaupoilta",
      "services.restaurants.cta": "Selaa",
      "services.van.title": "Pakettiauto / Muutto",
      "services.van.description": "Omistettu pakettiauto huonekaluille ja isoille tavaroille",
      "services.van.cta": "Varaa pakettiauto",
      "stats.deliveries": "Toimituksia",
      "stats.partners": "Kumppaneita",
      "stats.cities": "Kaupunkeja",
      "stats.rating": "Arvosana",
      "features.title": "Miksi valita meidät",
      "features.fast.title": "Nopea toimitus",
      "features.fast.description": "Saman päivän toimitus kaikkialle Suomeen",
      "features.tracking.title": "Reaaliaikainen seuranta",
      "features.tracking.description": "Seuraa toimitustasi reaaliajassa",
      "features.secure.title": "Turvalliset maksut",
      "features.secure.description": "Turvalliset maksuvaihtoehdot",
      "features.support.title": "24/7 Tuki",
      "features.support.description": "Aina valmiina auttamaan",
      "partner.title": "Ryhdy kumppaniksi",
      "partner.description": "Liity ravintola- ja kauppaverkostoomme",
      "partner.cta": "Ryhdy kumppaniksi",
      "courier.title": "Ryhdy kuririksi",
      "courier.description": "Ansaitse rahaa toimittamalla IBIIP:llä",
      "courier.cta": "Hae nyt",
      "footer.company": "IBIIP OY",
      "footer.address": "Karviaistie 12, 00700 Helsinki",
      "footer.businessId": "Y-tunnus",
      "footer.rights": "Kaikki oikeudet pidätetään"
    }
  },
  fr: {
    translation: {
      // Partner Dashboard
      "partner.login.title": "Tableau de bord Partenaire",
      "partner.login.subtitle": "Connectez-vous pour gérer vos commandes",
      "partner.login.password": "Mot de passe",
      "partner.login.passwordPlaceholder": "Entrez votre mot de passe",
      "partner.login.loginButton": "Se connecter",
      "partner.login.loggingIn": "Connexion...",
      "partner.header.title": "Tableau de bord Partenaire",
      "partner.header.pendingOrders": "en attente",
      "partner.status.online": "En ligne",
      "partner.status.offline": "Hors ligne",
      "partner.status.goOnline": "Passer en ligne",
      "partner.status.goOffline": "Passer hors ligne",
      "partner.tabs.pending": "En attente",
      "partner.tabs.accepted": "Acceptées",
      "partner.tabs.all": "Toutes",
      "partner.orders.noOrders": "Aucune commande pour le moment",
      "partner.orders.items": "Articles",
      "partner.orders.customer": "Client",
      "partner.orders.delivery": "Livraison",
      "partner.orders.subtotal": "Vos revenus 💰",
      "partner.orders.deliveryFee": "Frais de livraison",
      "partner.orders.total": "Total",
      "partner.orders.note": "Note",
      "partner.orders.prepTime": "Temps de préparation",
      "partner.orders.selectPrepTime": "Sélectionner...",
      "partner.orders.minutes": "minutes",
      "partner.orders.accept": "Accepter",
      "partner.orders.reject": "Refuser",
      "partner.orders.startPreparation": "Commencer la préparation",
      "partner.orders.readyForDelivery": "Prêt pour livraison",
      "partner.orders.markDelivered": "Marquer comme livré",
      "partner.statusBadges.pending": "En attente",
      "partner.statusBadges.confirmed": "Confirmé",
      "partner.statusBadges.preparing": "En préparation",
      "partner.statusBadges.outForDelivery": "En livraison",
      "partner.statusBadges.delivered": "Livré",
      "partner.statusBadges.rejected": "Refusé",
      "partner.notifications.newOrder": "Nouvelle(s) commande(s) !",
      "partner.notifications.orderAccepted": "Commande acceptée",
      "partner.notifications.orderRejected": "Commande refusée",
      "partner.notifications.statusUpdated": "Statut mis à jour",
      "partner.notifications.welcome": "Bienvenue",
      "partner.notifications.disconnected": "Déconnecté",
      "partner.notifications.selectPrepTime": "Veuillez sélectionner un temps de préparation",
      "partner.reject.title": "Refuser la commande",
      "partner.reject.reason": "Raison du refus",
      "partner.reject.reasons.closed": "Restaurant fermé",
      "partner.reject.reasons.busy": "Trop occupé en ce moment",
      "partner.reject.reasons.itemUnavailable": "Article(s) indisponible(s)",
      "partner.reject.reasons.deliveryTooFar": "Adresse de livraison trop loin",
      "partner.reject.reasons.other": "Autre raison",
      "partner.reject.confirm": "Confirmer le refus",
      "partner.reject.cancel": "Annuler",
      "partner.reject.warning": "Le client sera automatiquement remboursé.",
      "partner.language": "Langue",
      // Site translations
      "nav.home": "Accueil",
      "nav.services": "Services",
      "nav.restaurants": "Restaurants",
      "nav.about": "A propos",
      "nav.contact": "Contact",
      "hero.tagline": "Precision. Performance. Confiance.",
      "hero.title": "Infrastructure de Livraison Intelligente",
      "hero.subtitle": "Solutions de livraison professionnelles pour entreprises et particuliers",
      "hero.cta": "Commencer",
      "services.title": "Nos Services",
      "services.pickup.title": "Livraison Ramassage",
      "services.pickup.description": "Recuperez vos articles dans les magasins, restaurants ou points relais",
      "services.pickup.cta": "Commander",
      "services.package.title": "Envoyer un Colis",
      "services.package.description": "Livraison de personne a personne dans un rayon de 40km",
      "services.package.cta": "Envoyer",
      "services.restaurants.title": "Restaurants et Commerces",
      "services.restaurants.description": "Commandez aupres des restaurants et commerces locaux",
      "services.restaurants.cta": "Parcourir",
      "services.van.title": "Fourgon / Demenagement",
      "services.van.description": "Fourgon dedie pour meubles et gros articles",
      "services.van.cta": "Reserver",
      "stats.deliveries": "Livraisons",
      "stats.partners": "Partenaires",
      "stats.cities": "Villes",
      "stats.rating": "Note",
      "features.title": "Pourquoi Nous Choisir",
      "features.fast.title": "Livraison Rapide",
      "features.fast.description": "Livraison le jour meme",
      "features.tracking.title": "Suivi en Temps Reel",
      "features.tracking.description": "Suivez votre livraison en direct",
      "features.secure.title": "Paiements Securises",
      "features.secure.description": "Options de paiement securisees",
      "features.support.title": "Support 24/7",
      "features.support.description": "Toujours la pour vous aider",
      "partner.title": "Devenir Partenaire",
      "partner.description": "Rejoignez notre reseau de restaurants et commerces",
      "partner.cta": "Devenir Partenaire",
      "courier.title": "Devenir Coursier",
      "courier.description": "Gagnez de l'argent en livrant avec IBIIP",
      "courier.cta": "Postuler",
      "footer.company": "IBIIP OY",
      "footer.address": "Karviaistie 12, 00700 Helsinki",
      "footer.businessId": "N de SIRET",
      "footer.rights": "Tous droits reserves"
    }
  },
  ar: {
    translation: {
      "partner.login.title": "لوحة تحكم الشريك",
      "partner.login.subtitle": "سجّل الدخول لإدارة طلباتك",
      "partner.login.password": "كلمة المرور",
      "partner.login.passwordPlaceholder": "أدخل كلمة المرور",
      "partner.login.loginButton": "تسجيل الدخول",
      "partner.login.loggingIn": "جاري تسجيل الدخول...",
      "partner.header.title": "لوحة تحكم الشريك",
      "partner.header.pendingOrders": "قيد الانتظار",
      "partner.status.online": "متصل",
      "partner.status.offline": "غير متصل",
      "partner.status.goOnline": "الاتصال",
      "partner.status.goOffline": "قطع الاتصال",
      "partner.tabs.pending": "قيد الانتظار",
      "partner.tabs.accepted": "مقبولة",
      "partner.tabs.all": "الكل",
      "partner.orders.noOrders": "لا توجد طلبات حالياً",
      "partner.orders.items": "العناصر",
      "partner.orders.customer": "العميل",
      "partner.orders.delivery": "التوصيل",
      "partner.orders.subtotal": "أرباحك 💰",
      "partner.orders.deliveryFee": "رسوم التوصيل",
      "partner.orders.total": "المجموع",
      "partner.orders.note": "ملاحظة",
      "partner.orders.prepTime": "وقت التحضير",
      "partner.orders.selectPrepTime": "اختر...",
      "partner.orders.minutes": "دقائق",
      "partner.orders.accept": "قبول",
      "partner.orders.reject": "رفض",
      "partner.orders.startPreparation": "بدء التحضير",
      "partner.orders.readyForDelivery": "جاهز للتوصيل",
      "partner.orders.markDelivered": "تم التوصيل",
      "partner.statusBadges.pending": "قيد الانتظار",
      "partner.statusBadges.confirmed": "مؤكد",
      "partner.statusBadges.preparing": "قيد التحضير",
      "partner.statusBadges.outForDelivery": "في الطريق",
      "partner.statusBadges.delivered": "تم التوصيل",
      "partner.statusBadges.rejected": "مرفوض",
      "partner.notifications.newOrder": "طلب(ات) جديدة!",
      "partner.notifications.orderAccepted": "تم قبول الطلب",
      "partner.notifications.orderRejected": "تم رفض الطلب",
      "partner.notifications.statusUpdated": "تم تحديث الحالة",
      "partner.notifications.welcome": "مرحباً",
      "partner.notifications.disconnected": "تم قطع الاتصال",
      "partner.notifications.selectPrepTime": "الرجاء اختيار وقت التحضير",
      "partner.reject.title": "رفض الطلب",
      "partner.reject.reason": "سبب الرفض",
      "partner.reject.reasons.closed": "المطعم مغلق",
      "partner.reject.reasons.busy": "مشغولون حالياً",
      "partner.reject.reasons.itemUnavailable": "العنصر(ات) غير متوفرة",
      "partner.reject.reasons.deliveryTooFar": "عنوان التوصيل بعيد جداً",
      "partner.reject.reasons.other": "سبب آخر",
      "partner.reject.confirm": "تأكيد الرفض",
      "partner.reject.cancel": "إلغاء",
      "partner.reject.warning": "سيتم استرداد المبلغ للعميل تلقائياً.",
      "partner.language": "اللغة",
      // Site
      "nav.home": "الرئيسية",
      "nav.services": "الخدمات",
      "nav.restaurants": "المطاعم",
      "nav.about": "من نحن",
      "nav.contact": "اتصل بنا",
      "hero.tagline": "دقة. اداء. ثقة.",
      "hero.title": "بنية توصيل ذكية",
      "hero.subtitle": "حلول توصيل احترافية",
      "hero.cta": "ابدا",
      "services.title": "خدماتنا",
      "services.pickup.title": "توصيل الطلبات",
      "services.pickup.description": "استلام من المتاجر والمطاعم",
      "services.pickup.cta": "اطلب الان",
      "services.package.title": "ارسال طرد",
      "services.package.description": "توصيل من شخص لشخص",
      "services.package.cta": "ارسال",
      "services.restaurants.title": "المطاعم والمتاجر",
      "services.restaurants.description": "اطلب من المطاعم المحلية",
      "services.restaurants.cta": "تصفح",
      "services.van.title": "شاحنة / نقل",
      "services.van.description": "نقل الاثاث والاغراض الكبيرة",
      "services.van.cta": "احجز",
      "stats.deliveries": "التوصيلات",
      "stats.partners": "الشركاء",
      "stats.cities": "المدن",
      "stats.rating": "التقييم",
      "features.title": "لماذا تختارنا",
      "features.fast.title": "توصيل سريع",
      "features.fast.description": "توصيل في نفس اليوم",
      "features.tracking.title": "تتبع مباشر",
      "features.tracking.description": "تتبع في الوقت الحقيقي",
      "features.secure.title": "دفع امن",
      "features.secure.description": "خيارات دفع امنة",
      "features.support.title": "دعم 24/7",
      "features.support.description": "دائما هنا للمساعدة",
      "partner.title": "كن شريكا",
      "partner.description": "انضم لشبكتنا",
      "partner.cta": "كن شريكا",
      "courier.title": "كن مندوب توصيل",
      "courier.description": "اكسب المال مع IBIIP",
      "courier.cta": "قدم طلبك",
      "footer.company": "IBIIP OY",
      "footer.address": "هلسنكي",
      "footer.businessId": "رقم السجل",
      "footer.rights": "جميع الحقوق محفوظة"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
